// Configuración de la aplicación

// Determinar el entorno
export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'development';
export const IS_PRODUCTION = ENVIRONMENT === 'production';
export const IS_DEVELOPMENT = !IS_PRODUCTION;

// Modo de desarrollo
export const DEV_MODE = IS_DEVELOPMENT;

// URL base de la API según el entorno
export const API_URL = IS_PRODUCTION
  ? process.env.REACT_APP_PROD_API_URL || '/api'
  : process.env.REACT_APP_DEV_API_URL || 'http://localhost:5000/api';

// Log de configuración solo en desarrollo para evitar warnings en producción
if (IS_DEVELOPMENT) {
  // eslint-disable-next-line no-console
  console.log('API_URL configurada:', { apiUrl: API_URL, environment: ENVIRONMENT });
}

// Tiempo de expiración del token (en milisegundos)
export const TOKEN_EXPIRATION = parseInt(process.env.REACT_APP_TOKEN_EXPIRATION) || 24 * 60 * 60 * 1000; // 24 horas

// Tiempo de inactividad antes de cerrar sesión automáticamente (en milisegundos)
export const INACTIVITY_TIMEOUT = parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT) || 30 * 60 * 1000; // 30 minutos

// Configuración de seguridad
export const SECURITY_CONFIG = {
  // Número máximo de intentos de inicio de sesión fallidos
  MAX_LOGIN_ATTEMPTS: parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS) || 5,
  // Tiempo de bloqueo después de superar el número máximo de intentos (en milisegundos)
  LOCKOUT_TIME: parseInt(IS_PRODUCTION 
    ? process.env.REACT_APP_PROD_LOCKOUT_TIME || '900000'
    : process.env.REACT_APP_DEV_LOCKOUT_TIME || '60000'),
  // Requerir verificación de email para iniciar sesión
  REQUIRE_EMAIL_VERIFICATION: (IS_PRODUCTION 
    ? process.env.REACT_APP_PROD_REQUIRE_EMAIL_VERIFICATION 
    : process.env.REACT_APP_DEV_REQUIRE_EMAIL_VERIFICATION) === 'true',
  // Tiempo de expiración del token de verificación de email (en milisegundos)
  EMAIL_VERIFICATION_EXPIRATION: parseInt(process.env.REACT_APP_EMAIL_VERIFICATION_EXPIRATION) || 24 * 60 * 60 * 1000,
  // Tiempo de expiración del token de restablecimiento de contraseña (en milisegundos)
  PASSWORD_RESET_EXPIRATION: parseInt(process.env.REACT_APP_PASSWORD_RESET_EXPIRATION) || 1 * 60 * 60 * 1000,
};

// Configuración de logs
export const LOG_CONFIG = {
  LEVEL: IS_PRODUCTION 
    ? process.env.REACT_APP_PROD_LOG_LEVEL || 'info'
    : process.env.REACT_APP_DEV_LOG_LEVEL || 'debug',
  ENABLE_REMOTE_LOGGING: (IS_PRODUCTION 
    ? process.env.REACT_APP_PROD_ENABLE_REMOTE_LOGGING 
    : process.env.REACT_APP_DEV_ENABLE_REMOTE_LOGGING) === 'true'
};
